export default {
  title: {
    en: 'OOPS!',
    ar: 'يا للأسف!'
  },
  text: {
    en: 'You have added the maximum number of family members.',
    ar: 'لقد وصلت إلى الحد الأقصى لعدد أفراد العائلة.'
  },
  button: {
    en: 'Ok',
    ar: 'حسنًا'
  }
};
